module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMy4xOTkiIGhlaWdodD0iMTguOTYyIiB2aWV3Qm94PSIwIDAgMjMuMTk5IDE4Ljk2MiI+DQogIDxwYXRoIGlkPSJJY29uX2ZlYXRoZXItY2hlY2siIGQ9Ik0yNC45NzEsOSwxMS45MjgsMjQuMzQ4LDYsMTcuMzcxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMy44ODYgLTYuODg2KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMyIvPg0KPC9zdmc+DQo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/check-icon.svg
// module id = 2578
// module chunks = 0